<template lang="pug">
.docusign
  ManagementPage(title="MsOutlook Integration"
                info="Configuration for MS Outlook Integration"
                :creatable="false"
                :searchable="false")

  .ms-outlook-config(v-if="this.config !== null")
    aiq-col.padding-10(:span="12")
      shared-auth-config(:name='name'
                         :config="config"
                         title="MsOutlook OAuth Configuration"
                         @update="onChange")
</template>

<script>
import SharedAuthConfig from './SharedAuthConfig.vue';
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';

export default {
  name: 'MsOutlookTab',
  components: {
    SharedAuthConfig,
    ManagementPage,
  },
  computed: {
    name() {
      return 'ms-outlook';
    },
  },
  data() {
    return {
      config: null,
    };
  },
  async mounted() {
    if (!this.name) {
      throw new Error(`name attribute should be set to use this component but ${this.name}`);
    }

    this.config = await this.$store.dispatch('integrations/getIntegration', { name: this.name });
  },
  methods: {
    async onUpdate(newConfig) {
      try {
        this.config = await this.$store.dispatch('integrations/updateIntegration', {
          name: this.name,
          payload: newConfig,
        });
        this.$aiq.notify.success('Updated');
      } catch (err) {
        this.$aiq.notify.error(`Failed: ${err.message}`);
      }
    },
    async onChange(subObject) {
      await this.onUpdate({ ...this.config, ...subObject });
    },

    async onEnabled(enabled) {
      await this.onUpdate({ ...this.config, enabled });
    },

    async onSpecificChange(field, value) {
      const docusign = { ...this.config.docusign, [field]: value };
      await this.onUpdate({ ...this.config, docusign });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
